import { CardDetails } from 'owa-actionable-message';
import { ClientItem } from 'owa-mail-store';
import loadCardDetailsForItem from './loadCardDetailsForItem';

export default async function getCardDetails(item: ClientItem): Promise<CardDetails[]> {
    if (item.adaptiveCardDetails) {
        return item.adaptiveCardDetails;
    }

    const cardDetails = (await loadCardDetailsForItem(item)) || [];
    return cardDetails;
}
